import { defineMessage } from '@redbubble/next/intl';
import ex1FImg from '../assets/models/ex1_f.png';
import ex1MImg from '../assets/models/ex1_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  extendedInternationalConversions,
  howToChooseSizeTshirtInstructions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 1
 * Classic t-shirt
 * cactus-bizzo
 * Data source: https://www.figma.com/file/APrcJzL2qFEoaRd5cHKcR6/Sizing---VM?node-id=102%3A1188&t=HmvOZ0xrFXTSRYSx-1
 */

export const experience1: PreQuerySizeGuideData = {
  internationalConversions: extendedInternationalConversions,
  fitIndicator: {
    value: 6 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex1MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Large. He usually wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 188 cm / 6’2”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 53 cm / 21”',
        }),
      ],
    },
    female: {
      imageUrl: ex1FImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Medium. She usually wears a size Medium.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 175 cm / 5’9”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 46 cm / 18”',
        }),
      ],
    },
  },
};
